<template>
    <modal-ui
        :id="id"
        size="modal-md"
        title="Восстановление записи">
        <form class="loader" @submit.prevent="submit">
            <loader-ui :is-show="loader" />
            <div class="mb-3">
                Восстановить <strong>{{ subject }}</strong>?
            </div>
            <div v-if="deleteReason" class="mb-3 small text-muted">
                Причина удаления: {{ deleteReason }}
            </div>
            <form-group-ui label="Причина восстановления (необязательно)">
                <text-area-ui
                    v-model="reason"
                    :maxlength="1000"
                    placeholder="Например: удалено по ошибке" />
            </form-group-ui>
            <div class="d-flex justify-content-center mt-3">
                <button-ui button-class="btn-success">
                    Восстановить
                </button-ui>
                <button-ui button-class="btn-outline-secondary ms-3" type="button" @click="cancel">
                    Отмена
                </button-ui>
            </div>
        </form>
    </modal-ui>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useModal } from "@/composables/useModal";
import useNotifications from "@/composables/useNotifications";

/**
 * modal.data: { subject, deleteReason?, request: (reason) => Promise }
 */
export default defineComponent({
    name: "RestoreRecordModal",
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const modal = useModal(props.id);
        const subject: string = modal.data.subject || 'запись';
        const deleteReason: string = modal.data.deleteReason || '';
        const request: (reason: string) => Promise<any> = modal.data.request;

        const reason = ref('');
        const loader = ref(false);

        function submit() {
            if (loader.value) return;
            loader.value = true;
            request(reason.value.trim()).then((response: any) => {
                modal.ok({ response });
            }).catch((e: any) => {
                if (!e?.__apiErrorNotified) {
                    useNotifications.error('Ошибка', 'Не удалось восстановить запись');
                }
            }).finally(() => {
                loader.value = false;
            });
        }

        function cancel() {
            modal.cancel({});
        }

        return { subject, deleteReason, reason, loader, submit, cancel };
    },
});
</script>
